import { Libraries } from '@react-google-maps/api'

// Debug logging to see what's happening with the environment variable
console.log('Environment check:', {
  hasEnvVar: !!process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  envVarLength: process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.length,
  nodeEnv: process.env.NODE_ENV
})

export const GOOGLE_MAPS_CONFIG = {
  id: "google-map-script",
  libraries: ['places', 'geometry'] as Libraries,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
}

// Debug logging to see the final config
console.log('Final Google Maps Config:', {
  ...GOOGLE_MAPS_CONFIG,
  googleMapsApiKey: GOOGLE_MAPS_CONFIG.googleMapsApiKey ? 'API Key is set' : 'API Key is missing'
}) 